import "./Coaches.css";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import FormModal from "../../../Components/Molecules/FormModal/FormModal";
import { PulseLoader } from "react-spinners";
import TextFieldInput from "../../../Components/Atoms/Inputs/TextField/TextFieldInput";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Menu, MenuItem, Pagination, Card, CardContent, Grid, Typography, Box, Chip, Divider, useTheme, useMediaQuery } from "@mui/material";
import AddTeamForm from "../../../Components/Organisms/Forms/AddTeamForm/AddTeamForm";
import DeleteForm from "../../../Components/Molecules/DeleteForm/DeleteForm";
import EditIcon from "@mui/icons-material/Edit";
import config from "../../../config";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&:first-child": {
    borderRadius: "5px 0 0 0",
  },
  "&:last-child": {
    borderRadius: "0 5px 0 0",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: config.PRIMARY_COLOR,
    color: theme.palette.common.white,
    fontSize: "15px",
  },
}));

const columns = [
  { id: "name", label: "Coach Name", minWidth: 150 },
  {
    id: "contactNumber",
    label: "Contact Number",
    minWidth: 150,
  },
  {
    id: "teams",
    label: "Teams",
    minWidth: 150,
  },
  {
    id: "operations",
    label: "",
    width: 145,
    minWidth: 145,
    maxWidth: 145,
    align: "right",
  },
];

function Coaches({
  page,
  searchData,
  search,
  setSearchData,
  setSearch,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  setFilter,
  coaches,
  setCoachDeleted,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div className="mainContainer">
      <div className="cont">
        <div className="header">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "10px",
            }}
          >
            {/* <TextFieldInput
              searchIcon={true}
              Required={false}
              type="text"
              placeholder={"Search"}
              className="SearchBar"
              name={"search"}
              change={(e) => setSearchData(e.target.value)}
              newValue={searchData}
              searchAction={() => {
                if (search != searchData) {
                  setSearch(searchData);
                }
              }}
              keyDown={(e) => {
                if (e.keyCode === 13)
                  if (search != searchData) {
                    setSearch(searchData);
                  }
              }}
            /> */}
            {/* <Filter country city activated setFilter={setFilter} /> */}
          </div>
          <PrimaryButton
            classBtn={"center addButton"}
            text={"Add New Coach"}
            style={{
              textTransform: "capitalize",
              borderRadius: "5px",
              color: config.SECONDARY_COLOR,
              backgroundColor: config.PRIMARY_COLOR,
              height: "40px",
              padding: "0 30px",
              minWidth: "100px",
              textWrap: "noWrap",
            }}
            click={() => {
              navigate("/coaches/add");
            }}
          />
        </div>
        {!loading ? (
          <>
            {!coaches?.length ? (
              <h3 style={{ textAlign: "center", margin: "50px" }}>
                No Coaches Added Yet!!
              </h3>
            ) : isMobile ? (
              <Paper
                className="tableCont"
                sx={{ width: "100%", padding: "20px", borderRadius: "10px" }}
              >
                <Grid container spacing={3}>
                  {coaches?.map((coach, index) => (
                    <Grid item xs={12} sm={6} key={coach?.id}>
                      <Card
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          transition: "transform 0.2s, box-shadow 0.2s",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            backgroundColor: config.PRIMARY_COLOR,
                            color: "white",
                            padding: "7px 12px",
                            borderRadius: "12px",
                            fontSize: "0.875rem",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Coach {index + 1}
                        </Box>
                        <CardContent sx={{ pt: 2 }}>
                          <Typography
                            variant="h5"
                            component="div"
                            gutterBottom
                            sx={{
                              fontWeight: "bold",
                              color: config.PRIMARY_COLOR,
                              mb: 2,
                            }}
                          >
                            {coach.name}
                          </Typography>

                          <Divider sx={{ my: 2 }} />

                          <Box sx={{ mb: 1 }}>
                            <Typography
                              variant="subtitle2"
                              color="text.secondary"
                              sx={{ mb: 1 }}
                            >
                              Contact Information
                            </Typography>
                            <Typography variant="body2">
                              <strong>Phone:</strong> {coach.contactNumber || "-"}
                            </Typography>
                          </Box>

                          <Box sx={{ mb: 1 }}>
                            <Typography
                              variant="subtitle2"
                              color="text.secondary"
                              sx={{ mb: 1 }}
                            >
                              Teams
                            </Typography>
                            {coach.teams?.length ? (
                              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                {coach.teams.map((team) => (
                                  <Chip
                                    key={team.id}
                                    label={team.name}
                                    size="small"
                                    sx={{
                                      backgroundColor: "#e3f2fd",
                                      color: "#1976d2",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => navigate(`/teams/${team.id}`)}
                                  />
                                ))}
                              </Box>
                            ) : (
                              <Typography variant="body2" color="text.secondary">
                                Not assigned to any teams
                              </Typography>
                            )}
                          </Box>

                          <Box
                            sx={{
                              mt: 2,
                              display: "flex",
                              gap: 1,
                              justifyContent: "center",
                            }}
                          >
                            <PrimaryButton
                              classBtn={"center"}
                              text={"Edit"}
                              style={{
                                textTransform: "capitalize",
                                borderRadius: "5px",
                                color: config.SECONDARY_COLOR,
                                backgroundColor: config.PRIMARY_COLOR,
                                height: "30px",
                                padding: "0 10px",
                                minWidth: "auto",
                              }}
                              click={() => navigate(`/coaches/edit/${coach?.id}`)}
                            />
                            <DeleteForm
                              setDeleted={setCoachDeleted}
                              disabled={coach?.teams?.length ? true : false}
                              id={coach?.id}
                              title={`Are you sure to delete ${coach?.name} ?`}
                              error="This coach is already in a team, Please edit the coach of this team"
                            />
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            ) : (
              <Paper
                className="tableCont"
                sx={{ width: "fit-content", minWidth: "100%" }}
              >
                <TableContainer>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <StyledTableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              width: column.width,
                              minWidth: column.minWidth,
                              maxWidth: column.maxWidth,
                            }}
                          >
                            {column.label}
                          </StyledTableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {coaches?.map((coach) => (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={coach?.id}
                        >
                          {columns.map((column) => {
                            const value = coach[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  padding: "10px",
                                  width: column.width,
                                  minWidth: column.minWidth,
                                  maxWidth: column.maxWidth,
                                }}
                              >
                                {column.id === "teams" ? (
                                  value?.length ? (
                                    <>
                                      {value?.map((team, i) => (
                                        <>
                                          {i === 0 ? "" : " - "}
                                          <span
                                            style={{
                                              textDecoration: "underline",
                                              color: config.PRIMARY_COLOR,
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              navigate(`/teams/${team?.id}`)
                                            }
                                          >
                                            {team?.name}
                                          </span>
                                        </>
                                      ))}
                                    </>
                                  ) : (
                                    "-"
                                  )
                                ) : column.id === "operations" ? (
                                  <>
                                    <PrimaryButton
                                      classBtn={"center deleteBtn"}
                                      text={"Edit"}
                                      style={{
                                        textTransform: "capitalize",
                                        borderRadius: "5px",
                                        color: config.SECONDARY_COLOR,
                                        backgroundColor: config.PRIMARY_COLOR,
                                        height: "30px",
                                        padding: "0 10px",
                                        minWidth: "auto",
                                        textWrap: "noWrap",
                                        marginRight: "5px",
                                      }}
                                      click={() =>
                                        navigate(`/coaches/edit/${coach?.id}`)
                                      }
                                    />
                                    <DeleteForm
                                      setDeleted={setCoachDeleted}
                                      disabled={coach?.teams?.length ? true : false}
                                      id={coach?.id}
                                      title={`Are you sure to delete ${coach?.name} ?`}
                                      error="This coach is already in a team, Please edit the coach of this team"
                                    />
                                  </>
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            )}
          </>
        ) : (
          <div className="loadingBox">
            <PulseLoader color={config.PRIMARY_COLOR} />
          </div>
        )}
      </div>
    </div>
  );
}

export default Coaches;
